export default __webpack_public_path__ + "static/media/file-upload.37486390.svg";